import styled from '@emotion/styled';
import { casinoColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { SearchIcon } from 'src/assets/icons/SearchIcon';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';

export const SearchAndFiltersWrapper = styled('div', { label: 'SearchAndFiltersWrapper' })`
    display: flex;
    flex-flow: row wrap;
    gap: 8px;
    margin-top: 8px;
    width: 100%;
`;

export const SearchInputWrapper = styled('div', { label: 'SearchInputWrapper' })`
    flex: 1 0 195px;
    height: 32px;
    position: relative;
`;

export const SearchInput = styled('input', { label: 'SearchInput' })`
    border: 0;
    color: ${casinoColors.txtColor};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.regular};
    height: 100%;
    padding: 8px;
    width: 100%;
    background-color: ${casinoColors.bgColorInput};

    &::placeholder {
        color: ${casinoColors.txtColor};
    }
`;

export const SearchIconWrapper = styled(SearchIcon, { label: 'SearchIconWrapper' })`
    margin: auto 8px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    fill: ${casinoColors.blueGray};
`;

export const FilterDropdownWrapper = styled('div', { label: 'FilterDropdownWrapper' })`
    position: relative;
    flex: 0 0 144px;
    height: 32px;
`;

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean; isFocused?: boolean }>`
    background-color: ${(props): string =>
        props.isSelected === true || props.isFocused === true ? casinoColors.lighterBlue : 'transparent'};
    color: ${(props): string =>
        props.isSelected === true || props.isFocused === true ? casinoColors.white : casinoColors.txtColor};
    cursor: pointer;
    display: block;
    padding: 6px 8px 6px 12px;
    font-size: ${fontSize.small};
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        background-color: ${casinoColors.lighterBlue};
        color: ${casinoColors.white};
    }
`;

export const getFilterDropdownStyles = <T, IsMulti extends boolean>(isActive: boolean): StylesConfig<T, IsMulti> => ({
    control: (base) => ({
        ...base,
        border: 0,
        borderRadius: 0,
        backgroundColor: isActive ? mainColors.default.light : casinoColors.bgColorInput,
        height: '32px',
        minHeight: '32px',
        fontSize: fontSize.small,
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        }
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 8px',
        height: '32px',
    }),
    placeholder: (base) => ({
        ...base,
        color: casinoColors.txtColor,
        fontSize: fontSize.small,
        top: '6px',
        left: '10px',
    }),
    singleValue: (base) => ({
        ...base,
        color: casinoColors.txtColor,
        fontSize: fontSize.small,
        top: '6px',
        left: '10px',
    }),
    dropdownIndicator: () => ({
        display: 'none',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
});

export const ArrowIconWrapper = styled(ChevronIcon, { label: 'ArrowIconWrapper' })`
    position: absolute;
    z-index: 2;
    top: 9px;
    right: 7px;
`;

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })`
    width: 11px;
    height: 8px;
    fill: ${casinoColors.white};
    flex-shrink: 0;
`;

export const DropdownOption = styled('div', { label: 'DropdownOption' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
    font-size: ${fontSize.small};
`;
